var render, staticRenderFns
import script from "./HomeMixChart.vue?vue&type=script&lang=js&"
export * from "./HomeMixChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/aims-dashboard/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1eddbede')) {
      api.createRecord('1eddbede', component.options)
    } else {
      api.reload('1eddbede', component.options)
    }
    
  }
}
component.options.__file = "src/components/HomeMixChart.vue"
export default component.exports